
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateMeetingDtoFormGroup() {
return new FormGroup({
    title: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(255)]),
    description: new FormControl<string | undefined>(''),
    meetingTypeId: new FormControl<number | undefined>(undefined),
    startAt: new FormControl<string | undefined>(''),
    endAt: new FormControl<string | undefined>(''),
    location: new FormControl<string | undefined>('', [Validators.maxLength(255)]),
    businessUnitIds: new FormControl<Array<number> | undefined>([]),
})
;
}
      